import { useEffect, useState } from 'react';
import { api } from 'services/api';
import { Surgerie } from 'types/surgerie';

export function useFetchSurgerie(status: string | undefined, id: string | undefined) {
  const [surgerie, setSurgerie] = useState<Surgerie | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    console.log('Fetching surgerie with status:', status, 'and id:', id);
    async function fetchSurgerie() {
      if (!id) return;
      setLoading(true);
      try {
        await api.get<Surgerie>(`/budgets/${id}`).then(response => {
          setSurgerie(response.data);
        });
      } catch (err) {
        console.error('Error fetching surgerie:', err);
      } finally {
        setLoading(false);
      }
    }
    fetchSurgerie();
  }, [id, status]);

  return { surgerie, loading };
}
